<template>
  <div id="restaurant-menu-mange-and-order-admin_app" class="easyRestaurantManager-admin-page">
    <div class="easyRestaurantManager-main-menu">
      <div class="easyRestaurantManager-menu-logo">
        <h3>RESTAURANT MANAGER</h3>
      </div>
      <div class="easyRestaurantManager-menu-item-warper">
        <router-link class="easyRestaurantManager-menu-item" to="/">
          Dashboard
        </router-link>
        <router-link class="easyRestaurantManager-menu-item" to="/menus">
          Menus
        </router-link>
        <router-link class="easyRestaurantManager-menu-item" to="/reservation_table">
          Reservation Table
        </router-link>
        <router-link class="easyRestaurantManager-menu-item" to="/settings">
          Settings
        </router-link>
      </div>
    </div>
    <router-view></router-view>
  </div>

  <!-- =========================================== -->

</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">

</style>
